import React, { useEffect } from 'react'

import { RegistrationStatus, VerifyResponse } from './SuccessStage'
import { Card } from 'react-bootstrap'
import SuccessRegistrationCard from './SuccessRegistrationCard'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'

const SuccessBody = (props: { resp: VerifyResponse }) => {
  const { resp } = props
  const { baseUrl } = useSelector((state: RootState) => state.misc)
  const { data: program } = useSelector((state: RootState) => state.program)
  const { data: institution } = useSelector(
    (state: RootState) => state.institution,
  )
  const { loadedViaCode } = useSelector((state: RootState) => state.misc)

  useEffect(() => {
    // Update the document title using the browser API
    document.title = `${program.name}: Abschluss | Feripro ${institution.name}`
  })
  return (
    <>
      <Card>
        <Card.Body>
          {resp.submitted ? (
            <>
              <Card.Title>
                <h2>Anmeldung erfolgreich abgeschlossen</h2>
              </Card.Title>
              <Card.Text>
                Ihre Anmeldungen wurden im System gespeichert und haben jeweils
                den folgenden Status:
              </Card.Text>
            </>
          ) : (
            <>
              <Card.Title>
                <h2>Fehler bei der Anmeldung</h2>
              </Card.Title>
              <Card.Text dangerouslySetInnerHTML={{ __html: resp.message }} />
            </>
          )}
        </Card.Body>
      </Card>
      {resp.info.registration_states &&
        Object.values(RegistrationStatus)
          .filter(status => !!resp.info.registration_states[status])
          .map((status, key) => (
            <SuccessRegistrationCard
              type={status}
              registrations={resp.info.registration_states[status]}
              key={key}
            />
          ))}
      {resp.submitted &&
        (loadedViaCode ? (
          <p>
            Bitte überprüfen Sie nun Ihren Veranstaltungspass, die neu
            hinzugebuchten Anmeldungen sollten dort erscheinen.
          </p>
        ) : (
          <p>
            Eine E-Mail mit weiteren Details wurde an die angegebene
            E-Mail-Adresse versendet. Vorsichtshalber sollte überprüft werden,
            ob die E-Mail nicht aus Versehen als Spam markiert wurde.
            {program.distribution_type === 'INSTANT' && (
              <span>
                {' '}
                Sie können Ihren Pass auch direkt über diesen{' '}
                <b>
                  <a href={`${baseUrl}${resp.pass_url}`}>Link</a>
                </b>{' '}
                aufrufen.
              </span>
            )}
          </p>
        ))}
    </>
  )
}

export default SuccessBody
